/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteFeV1RecoveryCodsId } from '../fn/recovery-cash-on-delivery/delete-fe-v-1-recovery-cods-id';
import { DeleteFeV1RecoveryCodsId$Params } from '../fn/recovery-cash-on-delivery/delete-fe-v-1-recovery-cods-id';
import { postFeV1RecoveryCods$Json } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-json';
import { PostFeV1RecoveryCods$Json$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-json';
import { postFeV1RecoveryCods$Plain } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-plain';
import { PostFeV1RecoveryCods$Plain$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-plain';
import { postFeV1RecoveryCodsIdLock } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-id-lock';
import { PostFeV1RecoveryCodsIdLock$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-id-lock';
import { postFeV1RecoveryCodsIdUnlock } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-id-unlock';
import { PostFeV1RecoveryCodsIdUnlock$Params } from '../fn/recovery-cash-on-delivery/post-fe-v-1-recovery-cods-id-unlock';
import { putFeV1RecoveryCodsId$Json } from '../fn/recovery-cash-on-delivery/put-fe-v-1-recovery-cods-id-json';
import { PutFeV1RecoveryCodsId$Json$Params } from '../fn/recovery-cash-on-delivery/put-fe-v-1-recovery-cods-id-json';
import { putFeV1RecoveryCodsId$Plain } from '../fn/recovery-cash-on-delivery/put-fe-v-1-recovery-cods-id-plain';
import { PutFeV1RecoveryCodsId$Plain$Params } from '../fn/recovery-cash-on-delivery/put-fe-v-1-recovery-cods-id-plain';
import { RecoveryCashOnDeliveryResponse } from '../models/recovery-cash-on-delivery-response';

@Injectable({ providedIn: 'root' })
export class RecoveryCashOnDeliveryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1RecoveryCods()` */
  static readonly PostFeV1RecoveryCodsPath = '/v1/recovery-cods';

  /**
   * Creates a new recovery COD.
   *
   * Creates a new recovery COD.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCods$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCods$Plain$Response(params?: PostFeV1RecoveryCods$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return postFeV1RecoveryCods$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new recovery COD.
   *
   * Creates a new recovery COD.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCods$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCods$Plain(params?: PostFeV1RecoveryCods$Plain$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.postFeV1RecoveryCods$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /**
   * Creates a new recovery COD.
   *
   * Creates a new recovery COD.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCods$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCods$Json$Response(params?: PostFeV1RecoveryCods$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return postFeV1RecoveryCods$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new recovery COD.
   *
   * Creates a new recovery COD.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCods$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1RecoveryCods$Json(params?: PostFeV1RecoveryCods$Json$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.postFeV1RecoveryCods$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /** Path part for operation `putFeV1RecoveryCodsId()` */
  static readonly PutFeV1RecoveryCodsIdPath = '/v1/recovery-cods/{id}';

  /**
   * Updates an existing recovery COD.
   *
   * Updates an existing recovery COD.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1RecoveryCodsId$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1RecoveryCodsId$Plain$Response(params: PutFeV1RecoveryCodsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return putFeV1RecoveryCodsId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing recovery COD.
   *
   * Updates an existing recovery COD.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1RecoveryCodsId$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1RecoveryCodsId$Plain(params: PutFeV1RecoveryCodsId$Plain$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.putFeV1RecoveryCodsId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /**
   * Updates an existing recovery COD.
   *
   * Updates an existing recovery COD.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1RecoveryCodsId$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1RecoveryCodsId$Json$Response(params: PutFeV1RecoveryCodsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryResponse>> {
    return putFeV1RecoveryCodsId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing recovery COD.
   *
   * Updates an existing recovery COD.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1RecoveryCodsId$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1RecoveryCodsId$Json(params: PutFeV1RecoveryCodsId$Json$Params, context?: HttpContext): Observable<RecoveryCashOnDeliveryResponse> {
    return this.putFeV1RecoveryCodsId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RecoveryCashOnDeliveryResponse>): RecoveryCashOnDeliveryResponse => r.body)
    );
  }

  /** Path part for operation `deleteFeV1RecoveryCodsId()` */
  static readonly DeleteFeV1RecoveryCodsIdPath = '/v1/recovery-cods/{id}';

  /**
   * Deletes a recovery COD.
   *
   * Deletes a recovery COD.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeV1RecoveryCodsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1RecoveryCodsId$Response(params: DeleteFeV1RecoveryCodsId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFeV1RecoveryCodsId(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a recovery COD.
   *
   * Deletes a recovery COD.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeV1RecoveryCodsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1RecoveryCodsId(params: DeleteFeV1RecoveryCodsId$Params, context?: HttpContext): Observable<void> {
    return this.deleteFeV1RecoveryCodsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1RecoveryCodsIdLock()` */
  static readonly PostFeV1RecoveryCodsIdLockPath = '/v1/recovery-cods/{id}/lock';

  /**
   * Locks a recovery COD to prevent modifications.
   *
   * Locks a recovery COD to prevent modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCodsIdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1RecoveryCodsIdLock$Response(params: PostFeV1RecoveryCodsIdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1RecoveryCodsIdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Locks a recovery COD to prevent modifications.
   *
   * Locks a recovery COD to prevent modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCodsIdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1RecoveryCodsIdLock(params: PostFeV1RecoveryCodsIdLock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1RecoveryCodsIdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1RecoveryCodsIdUnlock()` */
  static readonly PostFeV1RecoveryCodsIdUnlockPath = '/v1/recovery-cods/{id}/unlock';

  /**
   * Unlocks a recovery COD to allow modifications.
   *
   * Unlocks a recovery COD to allow modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1RecoveryCodsIdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1RecoveryCodsIdUnlock$Response(params: PostFeV1RecoveryCodsIdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1RecoveryCodsIdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlocks a recovery COD to allow modifications.
   *
   * Unlocks a recovery COD to allow modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1RecoveryCodsIdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1RecoveryCodsIdUnlock(params: PostFeV1RecoveryCodsIdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1RecoveryCodsIdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
